import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({top: 0, behavior: "smooth"}); // Scrollt zum Anfang der Seite
  }, [pathname]); // Führt aus, wenn sich der Pfad ändert

  return null; // Diese Komponente hat keine UI
};

export default ScrollToTop;